import { render, staticRenderFns } from "./Settings-Trainer.vue?vue&type=template&id=7941f09f&"
import script from "./Settings-Trainer.vue?vue&type=script&lang=js&"
export * from "./Settings-Trainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports